import { type ReactElement } from "react";

type Feature = {
  icon: ReactElement;
  title: string;
  desc: string;
};

const FEATURES: Feature[] = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="9" x2="9" y2="21" />
      </svg>
    ),
    title: "See the flavor profile, not just the formula",
    desc: "Changes mapped visually against quantifiable, defined sensory criteria",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
    title: "Hundreds of formulas, one taste profile",
    desc: "Swap ingredients freely — each combination shows the exact cost/kg",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <line x1="4" y1="20" x2="4" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="20" y1="20" x2="20" y2="14" />
      </svg>
    ),
    title: "Built for supply shifts & client pivots",
    desc: "Reformulate instantly when ingredients become unavailable or requirements change",
  },
];

export function SignInFeatureHero() {
  return (
    <aside className="signin-hero">
      <div className="signin-hero-inner">
        <div className="signin-hero-pill">AI Flavor Discovery Platform</div>
        <h2 className="signin-hero-headline">
          Design a flavor
          <br />
          in <em>minutes</em>,
          <br />
          not months.
        </h2>
        <p className="signin-hero-intro">
          N-OS is the world's first AI Flavor Discovery Platform — compressing
          weeks of lab iteration into hours, so you can design, test, and
          refine formulas without breaking the creative cycle.
        </p>
        <div className="signin-hero-features">
          {FEATURES.map((f) => (
            <div key={f.title} className="signin-hero-feature">
              <div className="signin-hero-feature-icon" aria-hidden>
                {f.icon}
              </div>
              <div>
                <div className="signin-hero-feature-title">{f.title}</div>
                <div className="signin-hero-feature-desc">{f.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <img className="signin-hero-watermark" src="/logo-bird.png" alt="" aria-hidden />
    </aside>
  );
}
